export default "__VITE_ASSET__LhvtWIFP__"